import { render, staticRenderFns } from "./CodeControl.vue?vue&type=template&id=56ccd7cc"
import script from "./CodeControl.vue?vue&type=script&lang=js"
export * from "./CodeControl.vue?vue&type=script&lang=js"
import style0 from "./CodeControl.vue?vue&type=style&index=0&id=56ccd7cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports